import React, {FC} from 'react';
import classNames from 'classnames';
import {Link} from 'react-router-dom';

import s from '../quickStartGuide.scss';

type LinkPropsType = {
    children: string;
    href: string;
    clickHandler: (linkText: string) => void;
};

const LinkWithAnalytics: FC<LinkPropsType> = ({children, href, clickHandler}) => {
    return (
        <Link to={href} className={s.boxLink} onClick={() => clickHandler(children)}>
            {children}
        </Link>
    );
};

type ContentPropsType = {
    clickHandler: (linkText: string) => void;
};

const ContentItems: FC<ContentPropsType> = ({clickHandler}) => {
    const CONTENT_ITEMS = [
        {
            number: 1,
            title: 'Choose Your Frames',
            content: (
                <p className={s.boxContent}>
                    Browse our{' '}
                    <LinkWithAnalytics href="/eyeglasses-collection" clickHandler={clickHandler}>
                        Eyeglasses
                    </LinkWithAnalytics>
                    ,{' '}
                    <LinkWithAnalytics href="/sunglasses" clickHandler={clickHandler}>
                        Sunglasses
                    </LinkWithAnalytics>
                    , and{' '}
                    <LinkWithAnalytics href="/progressive-lenses" clickHandler={clickHandler}>
                        Multifocals
                    </LinkWithAnalytics>{' '}
                    to find what you need.{' '}
                </p>
            ),
        },
        {
            number: 2,
            title: 'Try Them Online!',
            content: (
                <p className={s.boxContent}>
                    You can see how the glasses look on you with our Virtual Mirror or find your{' '}
                    <LinkWithAnalytics href="/how-to?tabindex=1" clickHandler={clickHandler}>
                        frame size
                    </LinkWithAnalytics>{' '}
                    glasses.
                </p>
            ),
        },
        {
            number: 3,
            title: 'Customize Your Lenses',
            content: (
                <p className={s.boxContent}>
                    Fill in or upload your prescription. You can also scan it from your current
                    glasses using our{' '}
                    <LinkWithAnalytics href="/scan" clickHandler={clickHandler}>
                        App
                    </LinkWithAnalytics>
                    .
                </p>
            ),
        },
        {
            number: 4,
            title: 'Complete Your Order',
            content: (
                <p className={s.boxContent}>
                    Follow its journey{' '}
                    <LinkWithAnalytics href="/tracking/search/" clickHandler={clickHandler}>
                        through email
                    </LinkWithAnalytics>{' '}
                    until it gets to your doorstep.
                </p>
            ),
        },
    ];
    return (
        <>
            {CONTENT_ITEMS.map(({number, title, content}) => (
                <li className={s.sectionBox} key={number}>
                    <div className={s.boxSub}>
                        <div className={s.boxTite}>
                            <span className={s.boxTiteCricle}>{number}</span>
                            <h2 className={s.boxTiteTx}>{title}</h2>
                        </div>
                        {content}
                    </div>
                </li>
            ))}
        </>
    );
};

type PropsType = {
    clickHandler: (linkText: string) => void;
};

/**
 * Quick Start Guide Content for Start Guide page
 * @returns {JSXElement} component
 */
export const QuickStartGuideContent: FC<PropsType> = ({clickHandler}) => {
    return (
        <>
            <div className={s.header}>
                <h1 className={s.title}>Quick Guide</h1>
                <p className={s.text}>Enjoy a 100% risk-free shopping experience</p>
            </div>
            <ul className={s.sectionOne}>
                <ContentItems clickHandler={clickHandler} />
                <li className={classNames(s.sectionBox, s.last)}>
                    <div className={s.boxSub}>
                        <div className={s.boxTite}>
                            <div className={s.boxCricleImg}>
                                <svg width="26" height="26" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="none" fillRule="evenodd">
                                        <circle cx="13" cy="13" r="13" />
                                        <g stroke="#FFF" strokeWidth="2">
                                            <path d="M7.935 5.943C5.257 8.621 5.8 13.506 9.147 16.853c3.347 3.347 8.232 3.89 10.91 1.212" />
                                            <path d="M16.63 9.541c3.47 3.266 5.237 6.896 3.949 8.108-1.289 1.213-5.146-.45-8.615-3.716-3.47-3.265-5.237-6.895-3.949-8.108 1.289-1.213 5.146.451 8.615 3.716z" />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <h2 className={s.boxTiteTx}>Need Contact Lenses?</h2>
                        </div>
                        <div className={s.boxContent}>
                            <LinkWithAnalytics
                                href="/how-to?tabindex=17"
                                clickHandler={clickHandler}
                            >
                                Learn how to order them online.
                            </LinkWithAnalytics>
                        </div>
                    </div>
                </li>
            </ul>
        </>
    );
};
